import { Direction, GrowthIndicatorValue } from '../ygdrasil/types/types'

export const isGreen = (value: GrowthIndicatorValue, direction: Direction) => {
  const _direction = direction === Direction.DECREASING ? -1 : 1
  if (typeof value.actual !== 'number') return false
  if (typeof value.goal !== 'number') return false
  if (value.goal === value.actual) return true
  return Math.sign(value.actual - value.goal) === _direction
}
